import {
  Component,
  Input,
  ViewChild,
  afterNextRender,
  signal,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { ISwiperConfigs } from '@core/models/domains/slider.model';

@Component({
  selector: 'iho-slide-banner',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './slide-banner.component.html',
  styleUrls: ['./slide-banner.component.scss'],
})
export class SlideBannerComponent {
  @ViewChild('template', { static: true }) template: any;
  @Input() dataSource: any;
  sliderConfigs!: ISwiperConfigs;
  resetSwiper = signal(true);
  constructor() {
    afterNextRender(() => {
      this.resetSwiper.set(false);
      setTimeout(() => this.resetSwiper.set(true), 0);
    });
  }
  ngAfterViewInit(): void {
    this.sliderConfigs = {
      swiperConfig: {
        slidesPerView: 'auto',
        spaceBetween: 15,
        grabCursor: true,
        //  spaceBetween: 20,
        breakpoints: {
          // when window width is >= 320px
          320: {
            slidesPerView: 'auto',
            spaceBetween: 20,
          },
          // when window width is >= 480px
          480: {
            slidesPerView: 'auto',
            spaceBetween: 30,
          },
          // when window width is >= 640px
          1200: {
            slidesPerView: 'auto',
            spaceBetween: 15,
            //  width:400,
          },
        },
      },
      cardType: 1,
      wrapperClasslist: ['w-full', 'h-full'],
      template: this.template,
    };
  }
}
